import { EAppTemplateType } from "templates-common-library/baseClasses/CompatibilityChecker";
import AppT9N from "../../../t9n/App/App.json";

export const templateBadgeMapping = {
  [EAppTemplateType.Reporter]: "New",

  [EAppTemplateType.Compare]: "Beta",
  [EAppTemplateType.Observer]: "Beta",
  [EAppTemplateType.Streamflow]: "Beta",

  [EAppTemplateType.Atlas]: "Updated",
  [EAppTemplateType.AttachmentViewer]: "Updated",
  [EAppTemplateType.Exhibit]: "Updated",
  [EAppTemplateType.Nearby]: "Updated",
  [EAppTemplateType.ZoneLookup]: "Updated",
};

const tags = { ...AppT9N.tags } as const;
type tagTypes = keyof typeof tags;

export const capabilitySearchMapping: {
  [template: string]: tagTypes[];
} = {
  [EAppTemplateType.ThreeDViewer]: [
    "@@instantapps_search_keyword_scene@@",
    "@@instantapps_search_keyword_3d@@",
    "@@instantapps_search_keyword_webScene@@",
    "@@instantapps_search_keyword_lineSight@@",
    "@@instantapps_search_keyword_measurement@@",
    "@@instantapps_search_keyword_slice@@",
    "@@instantapps_search_keyword_overviewMap@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_export2csv@@",
    "@@instantapps_search_keyword_csv@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_navigate@@",
    "@@instantapps_search_keyword_slides@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_elevationProfile@@",
    "@@instantapps_search_keyword_daylight@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_basemapGallery@@",
    "@@instantapps_search_keyword_pan@@",
    "@@instantapps_search_keyword_rotate@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_locator@@",
    "@@instantapps_search_keyword_locatorMap@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_measure@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_3dViewer@@",
    "@@instantapps_search_keyword_viewer@@",
    "@@instantapps_search_keyword_disableScroll@@",
    "@@instantapps_search_keyword_screenshot@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_docked@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_weatherVis@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_spin@@",
    "@@instantapps_search_keyword_locations@@",
    "@@instantapps_search_keyword_time@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_scale@@",
    "@@instantapps_search_keyword_layout@@",
    "@@instantapps_search_keyword_date@@",
    "@@instantapps_search_keyword_sight@@",
    "@@instantapps_search_keyword_shadow@@",
    "@@instantapps_search_keyword_weather@@",
    "@@instantapps_search_keyword_northArrow@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_coordinates@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customHeader@@",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_daylightWidget@@",
    "@@instantapps_search_keyword_fullscreen@@",
    "@@instantapps_search_keyword_fullScreen@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_hoverPop@@",
    "@@instantapps_search_keyword_informationPanel@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_showTable@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_floorFilter@@",
    "@@instantapps_search_keyword_floorPlan@@",
    "@@instantapps_search_keyword_building@@",
    "@@instantapps_search_keyword_indoors@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
    "@@instantapps_search_keyword_buildingExplorer@@",
    "@@instantapps_search_keyword_buildingSceneLayer@@",
  ],

  [EAppTemplateType.Atlas]: [
    "@@instantapps_search_keyword_3d@@",
    "@@instantapps_search_keyword_atlas@@",
    "@@instantapps_search_keyword_group@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_list@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_table@@",
    "@@instantapps_search_keyword_toggle@@",
    "@@instantapps_search_keyword_basemapGallery@@",
    "@@instantapps_search_keyword_measure@@",
    "@@instantapps_search_keyword_measurement@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_scene@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_swipe@@",
    "@@instantapps_search_keyword_swipeMode@@",
    "@@instantapps_search_keyword_coordinates@@",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_daylightWidget@@",
    "@@instantapps_search_keyword_elevationProfile@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_showTable@@",
    "@@instantapps_search_keyword_weather@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_export2PDF@@",
    "@@instantapps_search_keyword_screenshot@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_interactiveLegend@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  [EAppTemplateType.AttachmentViewer]: [
    "@@instantapps_search_keyword_attachment@@",
    "@@instantapps_search_keyword_attachments@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_fullscreen@@",
    "@@instantapps_search_keyword_image@@",
    "@@instantapps_search_keyword_video@@",
    "@@instantapps_search_keyword_pdf@@",
    "@@instantapps_search_keyword_photo@@",
    "@@instantapps_search_keyword_viewer@@",
    "@@instantapps_search_keyword_map@@",
    "@@instantapps_search_keyword_edit@@",
    "@@instantapps_search_keyword_editing@@",
    "@@instantapps_search_keyword_update@@",
    "@@instantapps_search_keyword_dataReview@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_locations@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_list@@",
    "@@instantapps_search_keyword_present@@",
    "@@instantapps_search_keyword_collection@@",
    "@@instantapps_search_keyword_tour@@",
    "@@instantapps_search_keyword_selection@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_featureSelection@@",
    "@@instantapps_search_keyword_attachmentViewer@@",
    "@@instantapps_search_keyword_relatedRecords@@",
    "@@instantapps_search_keyword_extent@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_fullScreen@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_address@@",
    "@@instantapps_search_keyword_popUp@@",
    "@@instantapps_search_keyword_layout@@",
    "@@instantapps_search_keyword_records@@",
    "@@instantapps_search_keyword_related@@",
    "@@instantapps_search_keyword_relatedTable@@",
    "@@instantapps_search_keyword_sort@@",
    "@@instantapps_search_keyword_sortBy@@",
    "@@instantapps_search_keyword_download@@",
    "@@instantapps_search_keyword_camera@@",
    "@@instantapps_search_keyword_angle@@",
    "@@instantapps_search_keyword_imageDirection@@",
    "@@instantapps_search_keyword_gps@@",
    "@@instantapps_search_keyword_imageZoom@@",
    "@@instantapps_search_keyword_imagePan@@",
    "@@instantapps_search_keyword_label@@",
    "@@instantapps_search_keyword_thumbnail@@",
    "@@instantapps_search_keyword_format@@",
    "@@instantapps_search_keyword_height@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_panel@@",
    "@@instantapps_search_keyword_effects@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_layerEffects@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
    "@@instantapps_search_keyword_autoplay@@",
	  "@@instantapps_search_keyword_autoPlay1@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
    "AppStudio" as any,
  ],

  [EAppTemplateType.Basic]: [
    "@@instantapps_search_keyword_3d@@",
    "@@instantapps_search_keyword_basic@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_disableScroll@@",
    "@@instantapps_search_keyword_embed@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_screenshot@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_scene@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_simple@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_webScene@@",
    "@@instantapps_search_keyword_extent@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_rotate@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  [EAppTemplateType.CategoryGallery]: [
    "@@instantapps_search_keyword_gallery@@",
    "@@instantapps_search_keyword_category@@",
    "@@instantapps_search_keyword_group@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_pan@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_sort@@",
    "@@instantapps_search_keyword_content@@",
    "@@instantapps_search_keyword_list@@",
    "@@instantapps_search_keyword_table@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_layers@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_categoryGallery@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_panel@@",
    "@@instantapps_search_keyword_itemType@@",
    "@@instantapps_search_keyword_logIn@@",
    "@@instantapps_search_keyword_signIn@@",
    "@@instantapps_search_keyword_organization@@",
    "@@instantapps_search_keyword_members@@",
    "@@instantapps_search_keyword_categories@@",
    "@@instantapps_search_keyword_card@@",
    "@@instantapps_search_keyword_owner@@",
    "@@instantapps_search_keyword_profile@@",
    "@@instantapps_search_keyword_link@@",
    "@@instantapps_search_keyword_user@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_date@@",
    "@@instantapps_search_keyword_views@@",
    "@@instantapps_search_keyword_created@@",
    "@@instantapps_search_keyword_modified@@",
    "@@instantapps_search_keyword_details@@",
    "@@instantapps_search_keyword_summary@@",
    "@@instantapps_search_keyword_grid@@",
    "@@instantapps_search_keyword_layout@@",
    "@@instantapps_search_keyword_sortBy@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_positionManager@@",
  ],

  [EAppTemplateType.Charts]: [
    "@@instantapps_search_keyword_chart@@",
    "@@instantapps_search_keyword_graph@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_scatterPlot@@",
    "@@instantapps_search_keyword_histogram@@",
    "@@instantapps_search_keyword_bar@@",
    "@@instantapps_search_keyword_line@@",
    "@@instantapps_search_keyword_pie@@",
    "@@instantapps_search_keyword_boxPlot@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_chartViewer@@",
    "@@instantapps_search_keyword_viewer@@",
    "@@instantapps_search_keyword_graphic@@",
    "@@instantapps_search_keyword_stats@@",
    "@@instantapps_search_keyword_statistical@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_layout@@",
    "@@instantapps_search_keyword_charts@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_titleLink@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  [EAppTemplateType.Compare]: [
    "@@instantapps_search_keyword_compare@@",
    "@@instantapps_search_keyword_compareMaps@@",
    "@@instantapps_search_keyword_compareScenes@@",
    "@@instantapps_search_keyword_sideBySide@@",
    "@@instantapps_search_keyword_sync@@",
    "@@instantapps_search_keyword_synchronizeMaps@@",
    "@@instantapps_search_keyword_synchronizePopups@@",
    "@@instantapps_search_keyword_descriptiveText@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_importBookmarks@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_scale@@",
    "@@instantapps_search_keyword_sort@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_export2PDF@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_titleLink@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_filters@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_basemapGallery@@",
    "@@instantapps_search_keyword_scalebar@@",
  ],

  [EAppTemplateType.Countdown]: [
    "@@instantapps_search_keyword_countdown@@",
    "@@instantapps_search_keyword_list@@",
    "@@instantapps_search_keyword_leaderboard@@",
    "@@instantapps_search_keyword_details@@",
    "@@instantapps_search_keyword_sort@@",
    "@@instantapps_search_keyword_highlight@@",
    "@@instantapps_search_keyword_ranking@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_3d@@",
    "@@instantapps_search_keyword_pin@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_scene@@",
    "@@instantapps_search_keyword_webScene@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_extent@@",
    "@@instantapps_search_keyword_rotate@@",
    "@@instantapps_search_keyword_compare@@",
    "@@instantapps_search_keyword_graphic@@",
    "@@instantapps_search_keyword_stats@@",
    "@@instantapps_search_keyword_statistical@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_summary@@",
    "@@instantapps_search_keyword_results@@",
    "@@instantapps_search_keyword_effects@@",
    "@@instantapps_search_keyword_layerEffects@@",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_titleLink@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_autoplay@@",
	  "@@instantapps_search_keyword_autoPlay1@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  [EAppTemplateType.Exhibit]: [
    "@@instantapps_search_keyword_exhibit@@",
    "@@instantapps_search_keyword_presentation@@",
    "@@instantapps_search_keyword_present@@",
    "@@instantapps_search_keyword_slide@@",
    "@@instantapps_search_keyword_slides@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_disableScroll@@",
    "@@instantapps_search_keyword_note@@",
    "@@instantapps_search_keyword_notes@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_autoplay@@",
    "@@instantapps_search_keyword_pdf@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_measure@@",
    "@@instantapps_search_keyword_measurement@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_extent@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_export2PDF@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_import@@",
    "@@instantapps_search_keyword_importBookmarks@@",
    "@@instantapps_search_keyword_transitions@@",
    "@@instantapps_search_keyword_slideTransitions@@",
    "@@instantapps_search_keyword_duration@@",
    "@@instantapps_search_keyword_tableOfContents@@",
    "@@instantapps_search_keyword_list@@",
    "@@instantapps_search_keyword_slideList@@",
    "@@instantapps_search_keyword_3d@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_sidePanel@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  [EAppTemplateType.Insets]: [
    "@@instantapps_search_keyword_inset@@",
    "@@instantapps_search_keyword_insets@@",
    "@@instantapps_search_keyword_insetMap@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_scale@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_importBookmarks@@",
    "@@instantapps_search_keyword_sort@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_export2PDF@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_titleLink@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_filters@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_basemapGallery@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  [EAppTemplateType.InteractiveLegend]: [
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_interactive@@",
    "@@instantapps_search_keyword_screenshot@@",
    "@@instantapps_search_keyword_layers@@",
    "@@instantapps_search_keyword_map@@",
    "@@instantapps_search_keyword_list@@",
    "@@instantapps_search_keyword_countsAmounts@@",
    "@@instantapps_search_keyword_types@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_time@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_interactiveLegend@@",
    "@@instantapps_search_keyword_effects@@",
    "@@instantapps_search_keyword_layerEffects@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_extent@@",
    "@@instantapps_search_keyword_graphic@@",
    "@@instantapps_search_keyword_stats@@",
    "@@instantapps_search_keyword_statistical@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_popUp@@",
    "@@instantapps_search_keyword_helpPanel@@",
    "@@instantapps_search_keyword_timeFilter@@",
    "@@instantapps_search_keyword_visualization@@",
    "@@instantapps_search_keyword_count@@",
    "@@instantapps_search_keyword_total@@",
    "@@instantapps_search_keyword_featureCount@@",
    "@@instantapps_search_keyword_zoomTo@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customHeader@@",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_customURLParam@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  [EAppTemplateType.ImageryApp]: [
    "@@instantapps_search_keyword_imagery@@",
    "@@instantapps_search_keyword_viewer@@",
    "@@instantapps_search_keyword_imageryViewer@@",
    "@@instantapps_search_keyword_image@@",
    "@@instantapps_search_keyword_measure@@",
    "@@instantapps_search_keyword_compare@@",
    "@@instantapps_search_keyword_visualization@@",
    "@@instantapps_search_keyword_visual@@",
    "@@instantapps_search_keyword_render@@",
    "@@instantapps_search_keyword_rendering@@",
    "@@instantapps_search_keyword_selector@@",
    "@@instantapps_search_keyword_footprints@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_date@@",
    "@@instantapps_search_keyword_edit@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_swipe@@",
    "@@instantapps_search_keyword_swipeMode@@",
    "@@instantapps_search_keyword_disableScroll@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_extent@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_panel@@",
    "@@instantapps_search_keyword_imageSelector@@",
    "@@instantapps_search_keyword_imageMeasurement@@",
    "@@instantapps_search_keyword_measurement@@",
    "@@instantapps_search_keyword_degree@@",
    "@@instantapps_search_keyword_radian@@",
    "@@instantapps_search_keyword_meters@@",
    "@@instantapps_search_keyword_miles@@",
    "@@instantapps_search_keyword_kilometers@@",
    "@@instantapps_search_keyword_searchField@@",
    "@@instantapps_search_keyword_autoRefresh@@",
    "@@instantapps_search_keyword_dateRange@@",
    "@@instantapps_search_keyword_list@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_save@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_coordinates@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_detailsPanel@@",
    "@@instantapps_search_keyword_editing@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
  ],

  [EAppTemplateType.Manager]: [
    "@@instantapps_search_keyword_manager@@",
    "@@instantapps_search_keyword_edit@@",
    "@@instantapps_search_keyword_editing@@",
    "@@instantapps_search_keyword_crowdsourceManager@@",
    "@@instantapps_search_keyword_review@@",
    "@@instantapps_search_keyword_relatedRecords@@",
    "@@instantapps_search_keyword_attachments@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_basemapGallery@@",
    "@@instantapps_search_keyword_table@@",
    "@@instantapps_search_keyword_selection@@",
    "@@instantapps_search_keyword_popUp2Panel@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_attributes@@",
    "@@instantapps_search_keyword_fullScreen@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_csv@@",
    "@@instantapps_search_keyword_export2csv@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_popUp@@",
    "@@instantapps_search_keyword_popUp2@@",
    "@@instantapps_search_keyword_sort@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_crowdsource@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_floorFilter@@",
    "@@instantapps_search_keyword_floorPlan@@",
    "@@instantapps_search_keyword_building@@",
    "@@instantapps_search_keyword_indoors@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
  ],

  [EAppTemplateType.Media]: [
    "@@instantapps_search_keyword_time@@",
    "@@instantapps_search_keyword_media@@",
    "@@instantapps_search_keyword_measurement@@",
    "@@instantapps_search_keyword_embed@@",
    "@@instantapps_search_keyword_print@@",
    "@@instantapps_search_keyword_screenshot@@",
    "@@instantapps_search_keyword_hoverPop@@",
    "@@instantapps_search_keyword_map@@",
    "@@instantapps_search_keyword_popUp2@@",
    "@@instantapps_search_keyword_popUp@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_overviewMap@@",
    "@@instantapps_search_keyword_disableScroll@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_compare@@",
    "@@instantapps_search_keyword_toggle@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_swipe@@",
    "@@instantapps_search_keyword_measure@@",
    "@@instantapps_search_keyword_fullscreen@@",
    "@@instantapps_search_keyword_fullScreen@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_elevationProfile@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_export2csv@@",
    "@@instantapps_search_keyword_csv@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_mediaMap@@",
    "@@instantapps_search_keyword_docked@@",
    "@@instantapps_search_keyword_extent@@",
    "@@instantapps_search_keyword_swipeMode@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_table@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_scale@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customHeader@@",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_customURLParam@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_informationPanel@@",
    "@@instantapps_search_keyword_locatorMap@@",
    "@@instantapps_search_keyword_magnifier@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_showTable@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_floorFilter@@",
    "@@instantapps_search_keyword_floorPlan@@",
    "@@instantapps_search_keyword_building@@",
    "@@instantapps_search_keyword_indoors@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_details@@",
    "@@instantapps_search_keyword_attributes@@",
    "@@instantapps_search_keyword_coordinates@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_elevation@@",
    "@@instantapps_search_keyword_timeSlider@@",
    "@@instantapps_search_keyword_hover@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  // [EAppTemplateType.Minimalist]: [],

  [EAppTemplateType.Nearby]: [
    "@@instantapps_search_keyword_nearby@@",
    "@@instantapps_search_keyword_directions@@",
    "@@instantapps_search_keyword_lookup@@",
    "@@instantapps_search_keyword_route@@",
    "@@instantapps_search_keyword_routing@@",
    "@@instantapps_search_keyword_results@@",
    "@@instantapps_search_keyword_intersects@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_effects@@",
    "@@instantapps_search_keyword_layerEffects@@",
    "@@instantapps_search_keyword_map@@",
    "@@instantapps_search_keyword_layers@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_locations@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_list@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_groupResults@@",
    "@@instantapps_search_keyword_buffer@@",
    "@@instantapps_search_keyword_within@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_elevationProfile@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_locator@@",
    "@@instantapps_search_keyword_measurement@@",
    "@@instantapps_search_keyword_measure@@",
    "@@instantapps_search_keyword_screenshot@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_extent@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_export2PDF@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_pdf@@",
    "@@instantapps_search_keyword_export2csv@@",
    "@@instantapps_search_keyword_csv@@",
    "@@instantapps_search_keyword_proximity@@",
    "@@instantapps_search_keyword_distance@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_radius@@",
    "@@instantapps_search_keyword_distanceValues@@",
    "@@instantapps_search_keyword_distanceSlider@@",
    "@@instantapps_search_keyword_resultsList@@",
    "@@instantapps_search_keyword_minimum@@",
    "@@instantapps_search_keyword_maximum@@",
    "@@instantapps_search_keyword_intersecting@@",
    "@@instantapps_search_keyword_polygons@@",
    "@@instantapps_search_keyword_zones@@",
    "@@instantapps_search_keyword_miles@@",
    "@@instantapps_search_keyword_meters@@",
    "@@instantapps_search_keyword_kilometers@@",
    "@@instantapps_search_keyword_scale@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_informationPanel@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_titleLink@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
    "AppStudio" as any,
  ],

  [EAppTemplateType.Notify]: [
    "@@instantapps_search_keyword_publicNotification@@",
    "@@instantapps_search_keyword_notification@@",
    "@@instantapps_search_keyword_notify@@",
    "@@instantapps_search_keyword_report@@",
    "@@instantapps_search_keyword_selection@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_label@@",
    "@@instantapps_search_keyword_list@@",
    "@@instantapps_search_keyword_results@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_buffer@@",
    "@@instantapps_search_keyword_radius@@",
    "@@instantapps_search_keyword_csv@@",
    "@@instantapps_search_keyword_pdf@@",
    "@@instantapps_search_keyword_address@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_distance@@",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_measurement@@",
    "@@instantapps_search_keyword_measure@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  [EAppTemplateType.Observer]: [
    "@@instantapps_search_keyword_scene@@",
    "@@instantapps_search_keyword_3d@@",
    "@@instantapps_search_keyword_webScene@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_slides@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_scoreboard@@",
    "@@instantapps_search_keyword_observer@@",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_stats@@",
    "@@instantapps_search_keyword_statistical@@",
    "@@instantapps_search_keyword_summary@@",
    "@@instantapps_search_keyword_compass@@",
  ],

  [EAppTemplateType.Portfolio]: [
    "@@instantapps_search_keyword_portfolio@@",
    "@@instantapps_search_keyword_series@@",
    "@@instantapps_search_keyword_3d@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_content@@",
    "@@instantapps_search_keyword_scene@@",
    "@@instantapps_search_keyword_navigation@@",
    "@@instantapps_search_keyword_autoplay@@",
    "@@instantapps_search_keyword_preload@@",
    "@@instantapps_search_keyword_locations@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_layers@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_pan@@",
    "@@instantapps_search_keyword_rotate@@",
    "@@instantapps_search_keyword_print@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_video@@",
    "@@instantapps_search_keyword_webScene@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_embed@@",
    "@@instantapps_search_keyword_accordion@@",
    "@@instantapps_search_keyword_tabbed@@",
    "@@instantapps_search_keyword_carousel@@",
    "@@instantapps_search_keyword_compare@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_itemCollection@@",
    "@@instantapps_search_keyword_minimize@@",
    "@@instantapps_search_keyword_minimized@@",
    "@@instantapps_search_keyword_sections@@",
    "@@instantapps_search_keyword_section@@",
    "@@instantapps_search_keyword_basemapGallery@@",
    "@@instantapps_search_keyword_layout@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
  ],

  [EAppTemplateType.Reporter]: [
    "@@instantapps_search_keyword_reporter@@",
    "@@instantapps_search_keyword_edit@@",
    "@@instantapps_search_keyword_editing@@",
    "@@instantapps_search_keyword_crowdsourceReporter@@",
    "@@instantapps_search_keyword_relatedRecords@@",
    "@@instantapps_search_keyword_attachments@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_fullScreen@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_popUp@@",
    "@@instantapps_search_keyword_popUp2@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_crowdsource@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_filter@@",
	  "@@instantapps_search_keyword_filters@@",
    "@@instantapps_search_keyword_comment@@",
    "@@instantapps_search_keyword_like@@",
    "@@instantapps_search_keyword_dislike@@",
    "@@instantapps_search_keyword_vote@@",
    "@@instantapps_search_keyword_polling@@",
    "@@instantapps_search_keyword_signIn@@",
    "@@instantapps_search_keyword_sidePanel@@",
    "@@instantapps_search_keyword_relatedTable@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  [EAppTemplateType.Sidebar]: [
    "@@instantapps_search_keyword_edit@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_screenshot@@",
    "@@instantapps_search_keyword_sidebar@@",
    "@@instantapps_search_keyword_popUp@@",
    "@@instantapps_search_keyword_popUp2@@",
    "@@instantapps_search_keyword_details@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_disableScroll@@",
    "@@instantapps_search_keyword_sidePanel@@",
    "@@instantapps_search_keyword_panel@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_hoverPop@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_export2csv@@",
    "@@instantapps_search_keyword_csv@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_utilityNetwork@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_docked@@",
    "@@instantapps_search_keyword_extent@@",
    "@@instantapps_search_keyword_basemapGallery@@",
    "@@instantapps_search_keyword_export2PDF@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_pdf@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_minimalist@@",
    "@@instantapps_search_keyword_table@@",
    "@@instantapps_search_keyword_expand@@",
    "@@instantapps_search_keyword_expanded@@",
    "@@instantapps_search_keyword_create@@",
    "@@instantapps_search_keyword_update@@",
    "@@instantapps_search_keyword_snap@@",
    "@@instantapps_search_keyword_snapping@@",
    "@@instantapps_search_keyword_editing@@",
    "@@instantapps_search_keyword_trace@@",
    "@@instantapps_search_keyword_utility@@",
    "@@instantapps_search_keyword_utilities@@",
    "@@instantapps_search_keyword_network@@",
    "@@instantapps_search_keyword_utilityNetworkTrace@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_measure@@",
    "@@instantapps_search_keyword_measurement@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_customURLParam@@",
    "@@instantapps_search_keyword_detailsPanel@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_popUp2Panel@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_showTable@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_orientedImagery@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
    "AppStudio" as any,
  ],

  [EAppTemplateType.Slider]: [
    "@@instantapps_search_keyword_time@@",
    "@@instantapps_search_keyword_temporal@@",
    "@@instantapps_search_keyword_forecast@@",
    "@@instantapps_search_keyword_numeric@@",
    "@@instantapps_search_keyword_slider@@",
    "@@instantapps_search_keyword_animate@@",
    "@@instantapps_search_keyword_animation@@",
    "@@instantapps_search_keyword_date@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_screenshot@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_hoverPop@@",
    "@@instantapps_search_keyword_disableScroll@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_apps@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_docked@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_timeSlider@@",
    "@@instantapps_search_keyword_graphic@@",
    "@@instantapps_search_keyword_stats@@",
    "@@instantapps_search_keyword_statistical@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_number@@",
    "@@instantapps_search_keyword_searchField@@",
    "@@instantapps_search_keyword_range@@",
    "@@instantapps_search_keyword_rangeValues@@",
    "@@instantapps_search_keyword_effects@@",
    "@@instantapps_search_keyword_minimum@@",
    "@@instantapps_search_keyword_maximum@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_fullscreen@@",
    "@@instantapps_search_keyword_fullScreen@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
    "@@instantapps_search_keyword_autoplay@@",
	  "@@instantapps_search_keyword_autoPlay1@@",
    "@@instantapps_search_keyword_dateRange@@",
    "@@instantapps_search_keyword_filters@@",
    "@@instantapps_search_keyword_hover@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
  ],

  [EAppTemplateType.Streamflow]: [
    "@@instantapps_search_keyword_streamflow@@",
    "@@instantapps_search_keyword_streamflowViewer@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_maps@@",
    "@@instantapps_search_keyword_fullScreen@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_popUp@@",
    "@@instantapps_search_keyword_sort@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_time@@",
    "@@instantapps_search_keyword_chart@@",
    "@@instantapps_search_keyword_graph@@",
    "@@instantapps_search_keyword_forecast@@",
    "@@instantapps_search_keyword_filter@@",
	  "@@instantapps_search_keyword_filters@@",
  ],

  [EAppTemplateType.ZoneLookup]: [
    "@@instantapps_search_keyword_zone@@",
    "@@instantapps_search_keyword_lookup@@",
    "@@instantapps_search_keyword_zones@@",
    "@@instantapps_search_keyword_results@@",
    "@@instantapps_search_keyword_map@@",
    "@@instantapps_search_keyword_filter@@",
    "@@instantapps_search_keyword_layers@@",
    "@@instantapps_search_keyword_locate@@",
    "@@instantapps_search_keyword_effects@@",
    "@@instantapps_search_keyword_layerEffects@@",
    "@@instantapps_search_keyword_locations@@",
    "@@instantapps_search_keyword_find@@",
    "@@instantapps_search_keyword_location@@",
    "@@instantapps_search_keyword_directions@@",
    "@@instantapps_search_keyword_legend@@",
    "@@instantapps_search_keyword_list@@",
    "@@instantapps_search_keyword_search@@",
    "@@instantapps_search_keyword_groupResults@@",
    "@@instantapps_search_keyword_basemapToggle@@",
    "@@instantapps_search_keyword_screenshot@@",
    "@@instantapps_search_keyword_bookmarks@@",
    "@@instantapps_search_keyword_coverPage@@",
    "@@instantapps_search_keyword_district@@",
    "@@instantapps_search_keyword_navigationBoundary@@",
    "@@instantapps_search_keyword_layerList@@",
    "@@instantapps_search_keyword_share@@",
    "@@instantapps_search_keyword_sharing@@",
    "@@instantapps_search_keyword_cover@@",
    "@@instantapps_search_keyword_extent@@",
    "@@instantapps_search_keyword_zoneLookup@@",
    "@@instantapps_search_keyword_export2PDF@@",
    "@@instantapps_search_keyword_export@@",
    "@@instantapps_search_keyword_pdf@@",
    "@@instantapps_search_keyword_export2csv@@",
    "@@instantapps_search_keyword_csv@@",
    "@@instantapps_search_keyword_proximity@@",
    "@@instantapps_search_keyword_distance@@",
    "@@instantapps_search_keyword_within@@",
    "@@instantapps_search_keyword_header@@",
    "@@instantapps_search_keyword_title@@",
    "@@instantapps_search_keyword_info@@",
    "@@instantapps_search_keyword_intro@@",
    "@@instantapps_search_keyword_draw@@",
    "@@instantapps_search_keyword_introduction@@",
    "@@instantapps_search_keyword_introductionPanel@@",
    "@@instantapps_search_keyword_splash@@",
    "@@instantapps_search_keyword_splashScreen@@",
    "@@instantapps_search_keyword_onboarding@@",
    "@@instantapps_search_keyword_customCSS@@",
    "@@instantapps_search_keyword_currentLocation",
    "@@instantapps_search_keyword_customLogo@@",
    "@@instantapps_search_keyword_customTheme@@",
    "@@instantapps_search_keyword_home@@",
    "@@instantapps_search_keyword_positionManager@@",
    "@@instantapps_search_keyword_presetTheme@@",
    "@@instantapps_search_keyword_scalebar@@",
    "@@instantapps_search_keyword_sharedTheme@@",
    "@@instantapps_search_keyword_socialSharing@@",
    "@@instantapps_search_keyword_titleLink@@",
    "@@instantapps_search_keyword_zoomTools@@",
    "@@instantapps_search_keyword_compass@@",
    "@@instantapps_search_keyword_languageSwitcher@@",
    "@@instantapps_search_keyword_translate@@",
    "@@instantapps_search_keyword_translations@@",
    "@@instantapps_search_keyword_featureCount@@",
    "@@instantapps_search_keyword_filters@@",
    "@@instantapps_search_keyword_keyboardShortcuts@@",
    "@@instantapps_search_keyword_measurement@@",
    "@@instantapps_search_keyword_mapArea@@",
    "@@instantapps_search_keyword_mapView@@",
    "AppStudio" as any,
  ],
};
